export default __webpack_public_path__ + "static/media/hotspot_icon.65b3be63.png";